import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';
import { 
    SiDiscord, 
    SiBluesky, 
    SiReddit, 
    SiWhatsapp, 
    SiTelegram, 
    SiThreads, 
    SiPinterest
} from 'react-icons/si';
import { FaMedium } from 'react-icons/fa';

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    // Handle icons from react-icons (Simple Icons and Font Awesome)
    const reactIconsMap = {
        'Discord': SiDiscord,
        'Bluesky': SiBluesky,
        'Reddit': SiReddit,
        'WhatsApp': SiWhatsapp,
        'Telegram': SiTelegram,
        'Threads': SiThreads,
        'Medium': FaMedium,
        'Pinterest': SiPinterest
    };

    const ReactIconComponent = reactIconsMap[name];
    if (ReactIconComponent) {
        return <ReactIconComponent
            size={size}
            color={color}
            className={className}
            {...props}
        />;
    }

    // Handle Lucide icons
    const IconComponent = LucideIcons[name];

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;